import { useState } from "react";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import Refresh from '@mui/icons-material/Refresh';

function generateCaptcha() {
  const chars = "0123456789";
  return Array.from({ length: 2 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
}

export default function CustomCaptcha({ onVerify, requiredError = false }) {
  const [captcha, setCaptcha] = useState(generateCaptcha);
  const [input, setInput] = useState("");
  const [status, setStatus] = useState(null);

  const refreshCaptcha = () => {
    setCaptcha(generateCaptcha());
    setInput("");
    setStatus(null);
    onVerify(false);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setInput(value);
    // Keep the existing exact match and automatic refresh on a wrong answer.
    const verified = value === captcha;
    onVerify(verified);
    if (verified) {
      setStatus("success");
    } else if (value.length >= captcha.length) {
      setCaptcha(generateCaptcha());
      setInput("");
      setStatus("error");
    } else {
      setStatus(null);
    }
  };

  const hasError = status === "error" || requiredError;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      <Box className="portal-login-captcha-display" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, border: "1px solid #e2e8f0", borderRadius: "9px", px: 1.5, py: 0.5, background: "#f5f7fa" }}>
        <Typography component="span" sx={{ fontSize: 12, color: "#64748b" }}>Security code</Typography>
        <Typography component="span" aria-label={`Captcha challenge: ${captcha.split("").join(" ")}`} sx={{ fontFamily: "monospace", fontSize: 24, fontWeight: 700, letterSpacing: "6px", color: "#123047", userSelect: "none" }}>{captcha}</Typography>
        <IconButton type="button" aria-label="Refresh captcha" title="Refresh captcha" onClick={refreshCaptcha} sx={{ color: "#2563eb" }}><Refresh fontSize="small" /></IconButton>
      </Box>
      <TextField id="login-captcha" label="Captcha" placeholder="Enter security code" fullWidth autoComplete="off" value={input} onChange={handleChange} error={hasError} helperText={status === "error" ? "Incorrect captcha. Enter the new security code." : requiredError ? "Enter the security code to continue." : status === "success" ? "Security code verified." : null} slotProps={{ formHelperText: { "aria-live": "polite" } }} />
    </Box>
  );
}
